function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Layer_21",
  "data-name": "Layer 21"
},
/*#__PURE__*/
React.createElement("path", {
  d: "m23 16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 0-2h12a1 1 0 0 1 1 1zm7 0a14 14 0 1 1 -14-14 14 14 0 0 1 14 14zm-2 0a12 12 0 1 0 -12 12 12 12 0 0 0 12-12z"
}));

const SvgMinus = (_ref) => {
  let {
    svgRef,
    ...props
  } = _ref;
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      height: 512,
      viewBox: "0 0 32 32",
      width: 512,
      ref: svgRef
    }, props), _ref2)
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgMinus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/minus.9f0305c0.svg";
export { ForwardRef as ReactComponent };